import { fetchPost } from '@/utils/axiosfunc'

const api = {
  mobile: '/mobile',
  m: '/m',
  client: '/client',
  service: '/service',
  backend: '/backend',
  user: '/user',
  fanByOpenIdUrl: '/getFanByOpenId.do',
  bindUsersUrl: '/getBindUsers_businesshall',
  waterBillUrl: '/waterBillForLvchengJSON.do'
}

export default api

export function getUserFanReq (parameter) {
  return fetchPost(api.mobile + api.m + api.fanByOpenIdUrl, parameter)
}

export function getFanBinReq (parameter) {
  return fetchPost(api.mobile + api.m + api.bindUsersUrl, parameter)
}

export function getWaterBillReq (parameter) {
  return fetchPost(api.mobile + api.m + api.waterBillUrl, parameter)
}
